import { FACILITY_USER_ACCESS_MODE } from '@/constants/facilityUserAccessModes';

const normalizeIds = (ids = []) =>
  ids.map((id) => {
    const normalizedId = parseInt(id, 10);

    if (!Number.isFinite(normalizedId)) {
      throw new Error(`Invalid facility scope id: ${id}`);
    }

    return normalizedId;
  });

export const buildFacilityUserScopePayload = ({
  accessMode,
  facilityIds = [],
  facilityGroupIds = [],
}) => {
  switch (accessMode) {
    case FACILITY_USER_ACCESS_MODE.ALL_FACILITIES:
      return {
        access_mode: FACILITY_USER_ACCESS_MODE.ALL_FACILITIES,
        facility_ids: [],
        facility_group_ids: [],
      };
    case FACILITY_USER_ACCESS_MODE.FACILITY_GROUPS:
      return {
        access_mode: FACILITY_USER_ACCESS_MODE.FACILITY_GROUPS,
        facility_ids: [],
        facility_group_ids: normalizeIds(facilityGroupIds),
      };
    case FACILITY_USER_ACCESS_MODE.DIRECT_FACILITIES:
      return {
        access_mode: FACILITY_USER_ACCESS_MODE.DIRECT_FACILITIES,
        facility_ids: normalizeIds(facilityIds),
        facility_group_ids: [],
      };
    default:
      throw new Error('Select a facility access mode before saving');
  }
};
